export const getContraEntryList = state => {
    return state.list
}

export const getContraEntryDataProps = state => {
    return state.props
}


// WEBPACK FOOTER //
// ./src/store/modules/contraEntry/getters.js